import { Injectable, OnDestroy } from '@angular/core';
import { SystemClient } from '@benefitsui/app/api/benefits-clients';
import { environment } from '@benefitsui/environments/environment';
import { Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalTimeoutService implements OnDestroy {
  constructor(private systemClient: SystemClient) {
    this.initiateTimeout();
  }

  timeoutSubject = new Subject<null>();
  timeout?: number;
  sessionSubscription = new Subscription();

  ngOnDestroy(): void {
    this.sessionSubscription?.unsubscribe();
  }

  initiateTimeout(): void {
    this.timeout = window.setTimeout(() => {
      this.showTimeout();
    }, environment.portalTimeoutMilliseconds);
  }

  resetTimeout(): void {
    clearTimeout(this.timeout);
    this.initiateTimeout();
  }

  refreshServerSession(): void {
    this.resetTimeout();
    this.sessionSubscription = this.systemClient.ping().subscribe();
  }

  showTimeout(): void {
    this.timeoutSubject.next(null);
  }
}
